import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCoins, faPlusCircle, faSortDown, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: true,
  selector: 'atom-dropdown-price',
  imports: [CommonModule, FontAwesomeModule, RouterModule, CloseOnOutsideDirective],
  templateUrl: './dropdown-price.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
      :host .shadow-dropdown {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownPriceAtom implements OnInit {
  @Input() book!: any;
  @Input() index!: number;
  @Input() prices!: any;
  isDropdown = false;
  faIcons = {
    iconSortDown: faSortDown,
    iconCoins: faCoins,
    iconPlus: faPlusCircle,
    iconTimesCircle: faTimesCircle,
  };

  @Output() action = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  openDropdown() {
    this.isDropdown = !this.isDropdown;
  }
  closeDropdown() {
    this.isDropdown = false;
  }
}
